// Chapéu de bruxa (preto, com faixa laranja-terracota) para o personagem no Halloween.
// 14×8, a última linha encosta na testa (linha 5 do quadro; os olhos ficam nas linhas 6–7).
// Sem laranja na paleta: a faixa usa a rampa 'pot', como a abóbora da decoração sazonal.

import { sprite } from './pix.js';
import type { PixelSprite } from './types.js';

export const CHAPEU_BRUXA: PixelSprite = sprite(
  [
    '.......oo.....',
    '......okko....',
    '.....okkkko...',
    '.....okKkko...',
    '....okkkkkko..',
    '....obbbbbbo..',
    '.ookkkkkkkkoo.',
    '.oooooooooooo.',
  ],
  { o: 'black0', k: 'black2', K: 'black3', b: 'pot2' },
);
